import { combineReducers } from 'redux'

// Action Types
export const FETCH_RAMS_DASHBOARD_REQUEST = 'FETCH_RAMS_DASHBOARD_REQUEST'
export const FETCH_RAMS_DASHBOARD_SUCCESS = 'FETCH_RAMS_DASHBOARD_SUCCESS'
export const FETCH_RAMS_DASHBOARD_FAILURE = 'FETCH_RAMS_DASHBOARD_FAILURE'

export const FETCH_RAMS_ACTIVE_REQUEST = 'FETCH_RAMS_ACTIVE_REQUEST'
export const FETCH_RAMS_ACTIVE_SUCCESS = 'FETCH_RAMS_ACTIVE_SUCCESS'
export const FETCH_RAMS_ACTIVE_FAILURE = 'FETCH_RAMS_ACTIVE_FAILURE'

export const FETCH_RAMS_SETTINGS_REQUEST = 'FETCH_RAMS_SETTINGS_REQUEST'
export const FETCH_RAMS_SETTINGS_SUCCESS = 'FETCH_RAMS_SETTINGS_SUCCESS'
export const FETCH_RAMS_SETTINGS_FAILURE = 'FETCH_RAMS_SETTINGS_FAILURE'

export const FETCH_RAMS_PROJECTS_LIST_REQUEST = 'FETCH_RAMS_PROJECTS_LIST_REQUEST'
export const FETCH_RAMS_PROJECTS_LIST_SUCCESS = 'FETCH_RAMS_PROJECTS_LIST_SUCCESS'
export const FETCH_RAMS_PROJECTS_LIST_FAILURE = 'FETCH_RAMS_PROJECTS_LIST_FAILURE'

export const FETCH_RAMS_DOCUMENTS_REQUEST = 'FETCH_RAMS_DOCUMENTS_REQUEST'
export const FETCH_RAMS_DOCUMENTS_SUCCESS = 'FETCH_RAMS_DOCUMENTS_SUCCESS'
export const FETCH_RAMS_DOCUMENTS_FAILURE = 'FETCH_RAMS_DOCUMENTS_FAILURE'

export const UPLOAD_RAMS_DOCUMENT_REQUEST = 'UPLOAD_RAMS_DOCUMENT_REQUEST'
export const UPLOAD_RAMS_DOCUMENT_SUCCESS = 'UPLOAD_RAMS_DOCUMENT_SUCCESS'
export const UPLOAD_RAMS_DOCUMENT_FAILURE = 'UPLOAD_RAMS_DOCUMENT_FAILURE'

export const DELETE_RAMS_DOCUMENT_REQUEST = 'DELETE_RAMS_DOCUMENT_REQUEST'
export const DELETE_RAMS_DOCUMENT_SUCCESS = 'DELETE_RAMS_DOCUMENT_SUCCESS'
export const DELETE_RAMS_DOCUMENT_FAILURE = 'DELETE_RAMS_DOCUMENT_FAILURE'

export const TOGGLE_RAMS_DOCUMENT_REQUEST = 'TOGGLE_RAMS_DOCUMENT_REQUEST'
export const TOGGLE_RAMS_DOCUMENT_SUCCESS = 'TOGGLE_RAMS_DOCUMENT_SUCCESS'
export const TOGGLE_RAMS_DOCUMENT_FAILURE = 'TOGGLE_RAMS_DOCUMENT_FAILURE'

export const SET_RAMS_STATUS_FILTER = 'SET_RAMS_STATUS_FILTER'

// Dashboard Reducer
const dashboardInitialState = {
  data: {},
  fetching: false,
  error: null,
}

const dashboard = (state = dashboardInitialState, action) => {
  switch (action.type) {
    case FETCH_RAMS_DASHBOARD_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_RAMS_DASHBOARD_SUCCESS:
      return { ...state, fetching: false, data: action.payload, error: null }
    case FETCH_RAMS_DASHBOARD_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    default:
      return state
  }
}

// Active RAMS Reducer
const activeInitialState = {
  data: [],
  fetching: false,
  error: null,
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  projectFilter: null,
  statusFilter: [],
}

const active = (state = activeInitialState, action) => {
  switch (action.type) {
    case FETCH_RAMS_ACTIVE_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_RAMS_ACTIVE_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.rows || [],
        pagination: {
          current: action.payload.pagination.current_page || 1,
          total: action.payload.pagination.total || 0,
          pageSize: action.payload.pagination.per_page || 20,
        },
        error: null,
      }
    case FETCH_RAMS_ACTIVE_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    case SET_RAMS_STATUS_FILTER:
      return { ...state, statusFilter: action.payload }
    default:
      return state
  }
}

// Settings Reducer
const settingsInitialState = {
  data: {},
  fetching: false,
  error: null,
}

const settings = (state = settingsInitialState, action) => {
  switch (action.type) {
    case FETCH_RAMS_SETTINGS_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_RAMS_SETTINGS_SUCCESS:
      return { ...state, fetching: false, data: action.payload, error: null }
    case FETCH_RAMS_SETTINGS_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    default:
      return state
  }
}

// Projects List Reducer (for filter dropdown)
const projectsListInitialState = {
  data: [],
  fetching: false,
  error: null,
}

const projectsList = (state = projectsListInitialState, action) => {
  switch (action.type) {
    case FETCH_RAMS_PROJECTS_LIST_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_RAMS_PROJECTS_LIST_SUCCESS:
      return { ...state, fetching: false, data: action.payload, error: null }
    case FETCH_RAMS_PROJECTS_LIST_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    default:
      return state
  }
}

// Documents Reducer
const documentsInitialState = {
  data: [],
  fetching: false,
  error: null,
  uploading: false,
}

const documents = (state = documentsInitialState, action) => {
  switch (action.type) {
    case FETCH_RAMS_DOCUMENTS_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_RAMS_DOCUMENTS_SUCCESS:
      return { ...state, fetching: false, data: action.payload.rows || action.payload, error: null }
    case FETCH_RAMS_DOCUMENTS_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    case UPLOAD_RAMS_DOCUMENT_REQUEST:
      return { ...state, uploading: true }
    case UPLOAD_RAMS_DOCUMENT_SUCCESS:
      return { ...state, uploading: false, data: [action.payload.document, ...state.data] }
    case UPLOAD_RAMS_DOCUMENT_FAILURE:
      return { ...state, uploading: false, error: action.payload }
    case DELETE_RAMS_DOCUMENT_SUCCESS:
      return { ...state, data: state.data.filter(function(doc) { return doc.id !== action.payload.id }) }
    case TOGGLE_RAMS_DOCUMENT_SUCCESS:
      return {
        ...state,
        data: state.data.map(function(doc) {
          return doc.id === action.payload.id ? Object.assign({}, doc, { active: !doc.active }) : doc
        })
      }
    default:
      return state
  }
}

export default combineReducers({
  dashboard,
  active,
  settings,
  projectsList,
  documents,
})
